import { render, staticRenderFns } from "./insureOrder.vue?vue&type=template&id=77623aa4&scoped=true"
import script from "./insureOrder.vue?vue&type=script&lang=js"
export * from "./insureOrder.vue?vue&type=script&lang=js"
import style0 from "./insureOrder.vue?vue&type=style&index=0&id=77623aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77623aa4",
  null
  
)

export default component.exports